import ClinicsPage from "./pages/ClinicsPage";

require('./bootstrap');
//@ts-ignore
import WOW from 'wow.js/dist/wow.js';
//@ts-ignore
import 'wow.js/css/libs/animate.css';
import 'swiper/swiper.min.css';
import 'select2/dist/css/select2.min.css';
import * as Sentry from "@sentry/browser";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import CollapsableContent from "./components/CollapsableContent";
import SimpleForm from "./components/form/SimpleForm";
import PopupManager from "./managers/PopupManager";
import NoticeSpecializationPopup from "./components/NoticeSpecializationPopup";
import AcceptanceCookies from "./components/AcceptanceCookies";
import CustomSelect from "./components/form/CustomSelect";
import Slider from "./components/Slider";
import ToggleButton from "./components/ToggleButton";
import FeedbackForm from "./components/FeedbackForm";
import 'air-datepicker/air-datepicker.css';
import EventsPage from "./pages/EventsPage";
import MainVideoPreview from './components/MainVideoPreview';
import VideoPopup from './components/VideoPopup';
import SwipeIcon from "./components/SwipeIcon";
import ContactsPage from "./pages/ContactsPage";
import FeedbackComplaints from "./components/FeedbackComplaints";
import FileField from "./components/FileField";
import SearchPanel from "./components/SearchPanel";
import SearchPage from "./pages/SearchPage";
import ArticlesPage from "./pages/ArticlesPage";
import EventsDetailPage from "./pages/EventsDetailPage";
import MainPage from "./pages/main-page/MainPage";
import {MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH, MOBILE_DEVICE_REGEXP} from "./constans";
import MainPageCommonService from "./services/main-page/MainPageCommonService";
import MainPageThirdScreenCommon from './pages/main-page/screens/third/MainPageThirdScreenCommon';
import MainPageThirdScreenMobile from './pages/main-page/screens/third/MainPageThirdScreenMobile';

Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
    integrations: [],
    tracesSampleRate: 0,
});

$(document).on('DOMContentLoaded', function () {
    const setWindowVariables = () => {
        const setAppHeight = () => {
            const doc = document.documentElement;
            doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        };

        const setAppWidth = () => {
            const doc = document.documentElement;
            doc.style.setProperty('--app-width', `${window.innerWidth}px`);
        };


        setAppWidth();
        setAppHeight();

        window.addEventListener('resize', setAppHeight);
        window.addEventListener('resize', setAppWidth);

    };

    setWindowVariables();

    new WOW().init({
        live: true,
    });

    /**
     * Менеджер для работы с попапами
     */
    const popupManager = new PopupManager();

    /**
     * Попап предупреждение ио специализации сайта
     */
    new NoticeSpecializationPopup(popupManager);

    /**
     * Шапка
     */
    $('.js-header').each((_, element) => {
        new Header($(element));
    });

    /**
     * Подвал
     */
    $('.js-footer').each((_, element) => {
        new Footer($(element));
    });

    /**
     * Инициалзиация обычного слайдера
     */
    $('.js-slider').each((_, element) => {
        new Slider($(element));
    });

    /**
     * Инициализация скрывающего контента
     */
    $('.js-collapsable-content-init').each((index, element) => {
        $(element).data('collapsableContent', new CollapsableContent($(element)));
    });

    /**
     * Обычная форма
     */
    $('.js-simple-form').each((_, element) => {
        new SimpleForm($(element), popupManager);
    });

    $('.js-about0product-page').each((_, element) => {
        const applicationArea  = new MainPageThirdScreenCommon($(element));
        applicationArea.initEvents();

        if (window.innerWidth <= MAX_MOBILE_WIDTH) {
            const mobileApplications = new MainPageThirdScreenMobile($(element));
            mobileApplications.initMobileEvents();
        } else {
            applicationArea.switchToPrimaryBackground();
        }
    });
    /**
     * Куки
     */
    new AcceptanceCookies();

    /**
     * Кастомный селект
     */
    $('.js-select2').each((_, element) => {
        new CustomSelect($(element));
    });

    /**
     * Страница клиник
     */
    $('.js-clinics-page-holder').each((_, element) => {
        new ClinicsPage($(element));
    });



     /**
     * Страница "Карта дистрибьюторов"
     */
    $('.js-distributors-map-page').each((_, element) => {
        new DistributorsMapPage($(element));
    });




    /**
     * Скрипты для кнопки "переключателя"
     */
    $('.js-toggle').each((_, element) => {
        new ToggleButton($(element));
    });

    /**
     * Скрипты для форм обратной связи
     */
    $('.js-feedback-form-holder').each((_, element) => {
        new FeedbackForm($(element), popupManager);
    });

    /**
     * Скрипты для страницы мероприятий
     */
    $('.js-events-page').each((_, element) => {
        new EventsPage($(element));
    });

    /**
     * Скрипты для детальной страницы мероприятий
     */
    $('.js-events-detail-page').each((_, element) => {
        new EventsDetailPage($(element));
    });

    /**
     * Скрипты для страницы научных публикаций
     */
    $('.js-articles-page').each((_, element) => {
        new ArticlesPage($(element));
    });

    /**
     * Скрипты для видео превью
     */
    $('.js-video-preview').each((_, element) => {
        new MainVideoPreview($(element));
    })

    /**
     * Скрипты для анимации попапа с видео
     */
    $('.js-video-popup').each((_, element) => {
        new VideoPopup($(element), popupManager);
    });

    /**
     * Скрипты для иконки свайпа
     */
    $('.js-icon-swipe-wrapper').each((_, element) => {
        new SwipeIcon($(element));
    });

    /**
     * Скрипты для страницы контактов
     */
    $('.js-contacts-page').each((_, element) => {
        new ContactsPage($(element));
    });

    $('.js-complaints-form').each((_, element) => {
        new FeedbackComplaints($(element), popupManager);
    });

    /**
     * Инициализация поля загрузки файла
     */
    $('.js-file-field').each((_, element) => {
        $(element).data('fileField', new FileField($(element)));
    });

    /**
     * Инициализация поля поиска
     */
    $('.js-search-panel-wrapper').each((_, element) => {
        new SearchPanel($(element));
    });

    /**
     * Скрипты для страницы поиска
     */
    $('.js-search-page').each((_, element) => {
        new SearchPage($(element));
    });

    /**
     * Скрипты для главной страницы
     */
    $('.js-main-page').each((_, element) => {
        new MainPage($(element));
    });

    let moreArticlesItemCount = 3;
    let moreArticlesSpaceBetween = 30;
    let resultAfterUseItemCount = 2;
    let resultAfterUseBetween = 30;

    if (window.innerWidth <= MAX_TABLET_WIDTH) {
        moreArticlesItemCount = 2.07;
        moreArticlesSpaceBetween = 20;
        resultAfterUseItemCount = 1.07;
    }
    if (window.innerWidth <= MAX_MOBILE_WIDTH) {
        moreArticlesItemCount = 1.07;
        moreArticlesSpaceBetween = 12;
        resultAfterUseBetween = 10;
    }
    const swiperMoreArticlesSettings = {
        slidesPerView: moreArticlesItemCount,
        spaceBetween: moreArticlesSpaceBetween,
    }

    const swiperResultAfterSettings = {
        slidesPerView: resultAfterUseItemCount,
        spaceBetween: resultAfterUseBetween,
    }
    $('.js-more-articles-list').each((_, element) => {
        new Slider($(element), swiperMoreArticlesSettings);
    })
    $('.js-results-after-use').each((_, element) => {
        new Slider($(element), swiperResultAfterSettings);
    })
    const swiperHistorySettings = {

    }
    $('.js-history-slider').each((_, element) => {
        new Slider($(element), swiperHistorySettings, true)
    })
});
